import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const LineIntegral = () => (
  <QPhototModuleSubtopic
    title="Line integral"
    videos={[
      "https://www.youtube.com/embed/DRd0Rwh4rJs",
      "https://www.youtube.com/embed/J23hiEkzqLY"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_70.jpeg"
        },
        {
            image:"/cal_71.jpeg"
        },
        {
            image:"/cal_72.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default LineIntegral;
